export default {
	'restrictAlphabets': function restrictAlphabets(event) {
		if (event.keyCode == 46) {
			if (event.value && event.value.indexOf('.') >= 0) return true;else return false;
		} else if (event.keyCode < 48 || event.keyCode > 57) {
			event.preventDefault();
		}
	},
	'getClassCodesArray': function getClassCodesArray(perCapitaClassCodesFullData) {
		var perCapitaClasses = [];
		if (perCapitaClassCodesFullData.length > 0) {
			angular.forEach(perCapitaClassCodesFullData, function (data, key) {
				perCapitaClasses.push(data.classCode);
			});
		}
		return perCapitaClasses;
	},
	'checkFullTimePayrollMatch': function checkFullTimePayrollMatch(payrollData, currentPayroll) {
		var fullTimeMatch = false;
		angular.forEach(payrollData, function (comparingPayroll, comparingPayrollKey) {
			if (comparingPayroll.fullTime) {
				/**
     * checking each record with other records whether we have a match with high rating period
     * if so we don't need to push it
     */
				if (comparingPayroll.personsCovered == currentPayroll.personsCovered && comparingPayroll.earningsType == currentPayroll.earningsType && comparingPayroll.location == currentPayroll.location && comparingPayroll.classCode == currentPayroll.classCode && comparingPayroll.ratingDate > currentPayroll.ratingDate) {
					fullTimeMatch = true;
				}
			}
		});
		return fullTimeMatch;
	},
	'checkPartTimePayrollMatch': function checkPartTimePayrollMatch(payrollData, currentPayroll) {
		var partTimeMatch = false;
		angular.forEach(payrollData, function (comparingPayroll, comparingPayrollKey) {
			if (comparingPayroll.partTime) {
				/**
     * checking each record with other records whether we have a match with high rating period
     * if so we don't need to push it
     */
				if (comparingPayroll.personsCovered == currentPayroll.personsCovered && comparingPayroll.earningsType == currentPayroll.earningsType && comparingPayroll.location == currentPayroll.location && comparingPayroll.classCode == currentPayroll.classCode && comparingPayroll.ratingDate > currentPayroll.ratingDate) {

					partTimeMatch = true;
				}
			}
		});
		return partTimeMatch;
	},
	'checkFormErrors': function checkFormErrors(formErrors) {
		var errorAvailable = false;
		angular.forEach(formErrors, function (data) {

			if (data.reportedPayroll && data.reportedPayroll.status == false) {
				errorAvailable = true;
			}
			if (data.reportedPerCapita && data.reportedPerCapita.status == false) {
				errorAvailable = true;
			}
		});
		return errorAvailable;
	},
	'structuredError': function structuredError(message) {
		//Function that generates a specific message String based on error message returned from PC.
		if (message.includes("error:entity.WorkersCompLine/")) {
			message = message.split('error:entity.WorkersCompLine/').join('');
			if (message.includes(";") === true) var errorMessage = message.split(";");else var errorMessage = [message];
			var constructedErrorMessage = '';
			errorMessage.forEach(function construct(item, index) {
				constructedErrorMessage += index + 1 + '. ' + item + ' ';
			});
			return constructedErrorMessage;
		} else return message;
	}
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/util/PayrollReportingUtil_MSF.js
// module id = 338
// module chunks = 0